<div class=grid>
  <div class="col-4 lg:col-4 md:col-4" style="display: flex">
    <div class="col-6 lg:col-6 md:col-6" style="font-weight: bold">
      {{'TASASVARIABLES.LBL_NOMBRETASA' | translate}}
    </div>
    <div class="col-6 lg:col-6 md:col-6">
      {{registro.tasaVariable}}
    </div>
  </div>
  <div class="col-4 lg:col-4 md:col-4" style="display: flex">
    <div class="col-6 lg:col-6 md:col-6" style="font-weight: bold">
      {{'TASASVARIABLES.LBL_DIASVIGENCIA' | translate}}
    </div>
    <div class="col-6 lg:col-6 md:col-6">
      {{registro.diasVigencia}}
    </div>
  </div>
  <div class="col-4 lg:col-4 md:col-4" style="display: flex">
    <div class="col-6 lg:col-6 md:col-6" style="font-weight: bold">
      {{'TASASVARIABLES.LBL_VALORTASA' | translate}}
    </div>
    <div class="col-6 lg:col-6 md:col-6">
      {{registro.valorTasa}}
    </div>
  </div>
  <div class="col-4 lg:col-4 md:col-4" style="display: flex">
    <div class="col-6 lg:col-6 md:col-6" style="font-weight: bold">
      {{'TASASVARIABLES.LBL_FECHAINICIO' | translate}}
    </div>
    <div class="col-6 lg:col-6 md:col-6">
      {{registro.fechaInicioVigencia | date:'dd/MM/yyyy'}}
    </div>
  </div>
  <div class="col-4 lg:col-4 md:col-4" style="display: flex">
    <div class="col-6 lg:col-6 md:col-6" style="font-weight: bold">
      {{'TASASVARIABLES.LBL_FECHAFIN' | translate}}
    </div>
    <div class="col-6 lg:col-6 md:col-6">
      {{registro.fechaFinVigencia | date:'dd/MM/yyyy'}}
    </div>
  </div>
  <div class="col-4 lg:col-4 md:col-4" style="display: flex">
    <div class="col-6 lg:col-6 md:col-6" style="font-weight: bold">
      {{'TASASVARIABLES.LBL_ESTADO' | translate}}
    </div>
    <div class="col-6 lg:col-6 md:col-6">
      {{registro.estado}}
    </div>
  </div>
  <div class="col-4 lg:col-4 md:col-4" style="display: flex">
    <div class="col-6 lg:col-6 md:col-6" style="font-weight: bold">
      {{'TASASVARIABLES.LBL_CONFIGURACION' | translate}}
    </div>
    <div class="col-6 lg:col-6 md:col-6">
      {{registro.usuarioConfigura}}
    </div>
  </div>
  <div class="col-4 lg:col-4 md:col-4" style="display: flex">
    <div class="col-6 lg:col-6 md:col-6" style="font-weight: bold">
      {{'TASASVARIABLES.LBL_FECHACREACION' | translate}}
    </div>
    <div class="col-6 lg:col-6 md:col-6">
      {{registro.fechaCreacion | date:'dd/MM/yyyy HH:mm'}}
    </div>
  </div>
  <div class="col-4 lg:col-4 md:col-4" style="display: flex">
    <div class="col-6 lg:col-6 md:col-6" style="font-weight: bold">
      {{'TASASVARIABLES.LBL_APROBACION' | translate}}
    </div>
    <div class="col-6 lg:col-6 md:col-6">
      {{registro.usuarioAprueba}}
    </div>
  </div>
  <div class="col-4 lg:col-4 md:col-4" style="display: flex">
    <div class="col-6 lg:col-6 md:col-6" style="font-weight: bold">
      {{'TASASVARIABLES.LBL_FECHAAPROBACION' | translate}}
    </div>
    <div class="col-6 lg:col-6 md:col-6">
      {{registro.fechaAprobacion | date:'dd/MM/yyyy HH:mm'}}
    </div>
  </div>
  <div class="col-12 lg:col-12 md:col-12 flex" style="margin-bottom: 15px">
    <div class="col-2 lg:col-2 md:col-2" style="font-weight: bold">
      {{'TASASVARIABLES.LBL_OBSERVACION' | translate}}
    </div>
    <div class="col-10 lg:col-10 md:col-10" style="padding-left: 2px;">
      {{registro.observacion}}
    </div>
  </div>
</div>
